import getApi from '../../api'

export const deleteTask = (id: number) => getApi().delete<null>(`/tasks/${id}`)
